import React, { useEffect } from 'react';
import { Survey as SurveyModule, SurveyData } from '@dev/ee-modules';
import { EmailAPILogo } from '@dev/ee-components';

import { useSuccessConfig, useSurveyContentConfig } from './hooks';
import { useDispatch, useSelector } from 'react-redux';
import { getOnboardingSurveyStore, SaveOnboardingSurveyStart } from '@api/store/onboardingSurvey/actions';
import { useIntercom } from 'react-use-intercom';
import { sendEventToGTM } from '@dev/ee-tools';

export const OnboardingSurvey = (): JSX.Element => {
    const dispatch = useDispatch();
    const successConfig = useSuccessConfig();
    const surveyContent = useSurveyContentConfig();
    const { isSaved, isSaving } = useSelector(getOnboardingSurveyStore);
    const { shutdown, boot } = useIntercom() || {};

    const saveSurvey = (data: SurveyData): void => {
        dispatch(SaveOnboardingSurveyStart(data));
        boot();
    };

    const onSectionChange = (): void => {
        window.scroll(0, 0);
    };

    useEffect((): void => {
        sendEventToGTM('survey_start');

        // Shut down Intercom
        shutdown();
    }, []);

    const abortedEvents = (events): void => {
        if (events) {
            const data = events?.responses;
            const lastItem = data[data.length - 1];

            sendEventToGTM('Surveys', {
                category: 'Surveys',
                action: 'Last answered question ID [api product]',
                label: lastItem?.questionId,
            });
        }
    };

    return (
        <SurveyModule
            logoComponent={<EmailAPILogo />}
            banner={{ description: surveyContent.bannerText }}
            success={successConfig}
            content={surveyContent}
            saveCallback={saveSurvey}
            isSaving={isSaving}
            isSaved={isSaved}
            enableLocalStorage
            events={{
                sectionChanged: onSectionChange,
                aborted: abortedEvents,
            }}
        />
    );
};
